import http from "../../utils/httpClient";

class commissionService {
  getCommissionType = async (query) => {
    return await http.get(
      `/api/Commission/GetSellerCommisionType`, { params: query }
    );
  };
}

export default new commissionService();
